<template>
  <div class='mobile hamburger-header'>
    <div class='meatball' v-bind:class='{ open: open }' @click='onClick'>
      <span class='circle'></span>
      <span class='circle'></span>
      <span class='circle'></span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Meatball',
  components: {
  },
  data () {
    return {
      open: false
    };
  },
  mounted () {
  },
  methods: {
    onClick (e) {
      this.open = !this.open;
      this.$emit('open', this.open);
    }
  }
};

</script>



// WEBPACK FOOTER //
// src/components/Meatball.vue